// src/pages/expense/_shared/taxCalc.js
// ✅ 전 사업 확산 [3] — 용역사업 인건비 빠른입력(expense/service/SalaryPanel.jsx의
// confirmTaxCalc())에서 이미 검증된 "급여 총액 → 소득세/지방소득세/4대보험 자동계산"
// 로직을 공용 유틸로 추출한 것. 간이세액표(payroll/tax-table/lookup/, DB 자체가
// "공제대상가족 1명 기준"만 저장하도록 설계됨 — 즉 항상 가족수 1·100% 기준)와
// 4대보험 요율(insurance/rates/for-year/) 두 API를 조합한다. 경영팀 임직원급여
// SalaryPanel(business/SalaryPanel.jsx)이 이 함수를 재사용 — 계산 로직 중복 없음.
export async function calcPayrollTax(api, { totalSalary, draftDate }) {
  const ts = totalSalary;
  const year = Number((draftDate || "").slice(0, 4)) || new Date().getFullYear();
  const [taxRes, insRes] = await Promise.all([
    api.get("payroll/tax-table/lookup/", { params: { salary: ts, date: draftDate } }),
    api.get("insurance/rates/for-year/", { params: { year } }),
  ]);
  const { income_tax, local_tax } = taxRes.data;
  const r = insRes.data;
  const health = Math.round((ts * r.health_rate) / 100);
  const care = Math.round((health * r.care_rate) / 100);
  const pension = Math.round((ts * r.pension_rate) / 100);
  const employment = Math.round((ts * r.employ_rate) / 100);
  return {
    incomeTax: income_tax,
    localTax: local_tax,
    health,
    care,
    pension,
    employment,
    matchedYear: r.matched_year,
  };
}
